<template>
  <LoadingCircle v-if="isLoading"></LoadingCircle>
  <div v-else>
    <v-row no-gutters>
      <v-col cols="12">
        <HeaderWidget :header-text="welcomeText" type="Welcome" />
      </v-col>
    </v-row>
    <div v-if="noQuestionnaires" class="mt-15 text-center">
      <p>There is no data ready for your dashboard.</p>
      <p>Please create a questionnaire and send it to your suppliers.</p>
    </div>
    <div v-else>
      <v-row class="mt-2">
        <v-col cols="12" xs="6" sm="6" md="6" lg="3" xl="3">
          <SelectQuestionnairesWidget />
        </v-col>
        <v-col cols="12" xs="6" sm="6" md="6" lg="3" xl="3">
          <BusinessPartnersWidget />
        </v-col>
        <v-col cols="12" xs="6" sm="6" md="6" lg="3" xl="3">
          <SuppliersWidget />
        </v-col>
        <v-col cols="12" xs="6" sm="6" md="6" lg="3" xl="3">
          <SuppliersInChainWidget />
        </v-col>
      </v-row>

      <v-row v-if="notSent" justify="center">
        <p class="mt-15">
          This questionnaire has not been sent to any suppliers.
        </p></v-row
      >
      <div v-else>
        <v-row class="mt-3">
          <v-col cols="12" md="12" lg="6" xl="7" xxl="8">
            <MapWidget />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="5" xxl="4">
            <QuestionnaireStatusWidget />
          </v-col>
        </v-row>
        <v-row
          v-if="
            questionnairesStore.latestSentQuestionnaire &&
            statsStore.flagging.riskIndicatorsGroups.length > 0
          "
        >
          <v-col cols="12" xs="12" sm="6" md="6" lg="4" xl="3">
            <RedFlagsWidget />
          </v-col>
          <RiskWidgets />
        </v-row>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SuppliersWidget from "@/views/dashboard-view/SuppliersWidget.vue";
import BusinessPartnersWidget from "./BusinessPartnersWidget.vue";
import SuppliersInChainWidget from "@/views/dashboard-view/SuppliersInChainWidget.vue";
import QuestionnaireStatusWidget from "@/views/dashboard-view/QuestionnaireStatusWidget.vue";
import RiskWidgets from "@/views/dashboard-view/RiskWidgets.vue";
import { computed, onBeforeMount, ref } from "vue";
import { useStatsStore } from "@/stores/statsStore";
import LoadingCircle from "@/components/custom/LoadingCircle.vue";
import { useQuestionnairesStore } from "@/stores/questionnaires";
import RedFlagsWidget from "@/views/dashboard-view/RedFlagsWidget.vue";
import MapWidget from "@/views/dashboard-view/MapWidget.vue";
import SelectQuestionnairesWidget from "@/views/dashboard-view/SelectQuestionnairesWidget.vue";
import { useUserProfileStore } from "@/stores/userProfileStore";
import HeaderWidget from "@/components/widgets/HeaderWidget.vue";

const statsStore = useStatsStore();
const questionnairesStore = useQuestionnairesStore();
const userProfileStore = useUserProfileStore();

const userProfile = userProfileStore.userProfile;
const isLoading = ref(true);

const noQuestionnaires = computed(
  () => questionnairesStore.sentQuestionnaires.length == 0
);
const notSent = computed(
  () =>
    statsStore.stats.supplyChainAnswerStats.noSuppliers +
      statsStore.stats.supplyChainAnswerStats.noBusinessPartners ==
    0
);

const welcomeText = computed(() =>
  userProfile.name.length > 0
    ? "Welcome, " + userProfile.name + "!"
    : "Welcome!"
);

onBeforeMount(async () => {
  try {
    if (!questionnairesStore.selectedQuestionnaire.id) {
      await questionnairesStore.getLatestQuestionnaire();
      questionnairesStore.selectedQuestionnaire =
        questionnairesStore.latestSentQuestionnaire;
    }
    await statsStore.setStatsSummary(
      questionnairesStore.selectedQuestionnaire.id
    );
  } finally {
    isLoading.value = false;
  }
});
</script>
